import DashboardLayout from "src/pages/Dashboard/Layout/DashboardLayout.vue";
import AdminLayout from "src/pages/Dashboard/Layout/AdminLayout.vue";
import Logout from "src/Logout";
// GeneralViews
import NotFound from "src/pages/GeneralViews/NotFoundPage.vue";
// Dashboard pages
// Pages
import User from "src/pages/Dashboard/Pages/UserProfile.vue";
import Login from "src/pages/Dashboard/Pages/Login.vue";
import Lock from "src/pages/Dashboard/Pages/Lock.vue";
// Components pages
// Admin
import NewAdminForm from "src/pages/Dashboard/Pages/Admin/NewAdminForm.vue";
import AdminList from "src/pages/Dashboard/Pages/Admin/AdminList.vue";
import PendingUsers from "src/pages/Dashboard/Pages/Users/PendingList.vue";
import ActiveUsers from "src/pages/Dashboard/Pages/Users/ActiveList.vue";
import NewDeviceForm from "src/pages/Dashboard/Pages/Devices/NewDeviceForm.vue";
import EditDeviceForm from "src/pages/Dashboard/Pages/Devices/EditDeviceForm.vue";
import DeviceList from "src/pages/Dashboard/Pages/Devices/DevicesList.vue";
import history from "src/pages/Dashboard/Pages/Devices/history.vue";
import OptionsList from "src/pages/Dashboard/Pages/Options/OptionsList.vue";
import NewOptionForm from "../pages/Dashboard/Pages/Options/NewOptionForm";
import AmbienteCreate from "../pages/Dashboard/Pages/Ambiente/ambiente.vue";
import AmbienteList from "../pages/Dashboard/Pages/Ambiente/ambientelist.vue";

let userMenu = {
  path: "/user",
  component: DashboardLayout,
  redirect: "/user/profile",
  children: [
    {
      path: "profile",
      name: "Perfil del Administrador",
      component: User,
    },
  ],
};

let loginPage = {
  path: "/login",
  name: "Login",
  component: Login,
};

let lockPage = {
  path: "/lock",
  name: "Lock",
  component: Lock,
};

const routes = [
  {
    path: "/",
    redirect: "/user/profile",
  },
  {
    path: "/logout",
    component: Logout,
  },
  loginPage,
  lockPage,
  userMenu,
  {
    path: "/admin",
    component: DashboardLayout,
    children: [
      {
        path: "options",
        name: "New Admin L2",
        component: AdminLayout,
        children: [
          {
            path: "new",
            name: "Nueva Licencia",
            component: NewAdminForm,
          },
          {
            path: "list",
            name: "Licencias",
            component: AdminList,
          },
          {
            path: "institutions/new",
            name: "Crear Institución",
            component: PendingUsers,
          },
          {
            path: "institutions/active",
            name: "Instituciones",
            component: ActiveUsers,
          },
          {
            path: "identifier/new",
            name: "Nuevo Identificador",
            component: NewDeviceForm,
          },
          {
            path: "device/edit/:id",
            name: "Editar Dispositivo",
            component: EditDeviceForm,
          },
          {
            path: "options/new",
            name: "Nuevo Opcion",
            component: NewOptionForm,
          },
          {
            path: "options/list",
            name: "Opciones",
            component: OptionsList,
          },
          {
            path: "identifier/list",
            name: "Identificadores",
            component: DeviceList,
          },

          {
            path: "ambiente/new",
            name: "ambiente/new",
            component: AmbienteCreate,
          },

            {
            path: "ambiente/list",
            name: "ambiente/list",
            component: AmbienteList,
          },
          /*       {
            path: "list",
            name: "Ambiente/list",
            component: AmbienteList,
          }, */
          {
            path: "historico",
            name: "Historico",
            component: history,
          },
        ],
      },
    ],
  },
  { path: "*", component: NotFound },
];

export default routes;
